module.exports = __webpack_public_path__ + "img/zc_flow.aa403cf7.png";